import styled from "styled-components";

export const CardTitle = styled("h3")`
  font-size: 14px;
  font-weight: 500;
  color: #273241;
  margin-bottom: 15px;
`;
